import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WarehouseIcon(props: IconProps) {
    return <Icon {...props} iconKey={"warehouse"}/>
}
